import { jsxs, jsx } from 'react/jsx-runtime';
import cns from '../../../node_modules/classnames/index.js';
import useTooltipHoverWithDelay from '../Hooks/useTooltipHoverWithDelay.js';
import { Position } from '../../types.js';
import TooltipContent from './TooltipContent.js';

function Tooltip({ className = undefined, contentClassName = undefined, children, content, position = Position.bottom, type = undefined, show = undefined, onClose = undefined, onMouseEnter = undefined, onMouseLeave = undefined, }) {
    const showOnHover = show === undefined || show === null;
    return (jsxs("div", { className: cns('v2-tooltip', { 'v2-tooltip--show-on-hover': showOnHover }, `v2-tooltip--${position}`, { [`v2-tooltip--${type}`]: !!type }, className), onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, children: [(content && (show || showOnHover))
                && (jsx(TooltipContent, { className: contentClassName, onClose: showOnHover ? undefined : onClose, children: content })), children] }));
}
/**
Il componente avvolge un qualsiasi componente aggiungendo un tooltip che compare all'hover.
Se lo stato è uncontrolled, il tooltip funziona al hover dei children.

Il contenuto deve avere tra le 9 e le 12 parole per riga.

Utilities:

- `Tooltip.useTooltipHoverWithDelay`: Questo componente gestite lo stato di un componente Tooltip ritardando la chiusura di delay millisecondi. Deve essere utilizzato quando il contenuto del tooltip ha dei componenti attivi, ad esempio un link, e il delay deve essere scelto per dare il tempo all'utente di agire.
*/
const TooltipOld = Tooltip;
TooltipOld.useTooltipHoverWithDelay = useTooltipHoverWithDelay;
TooltipOld.Content = TooltipContent;

export { TooltipOld as default };
